import { Route } from 'react-router-dom';
import { AcademicYearRequired } from '@/components/common/AcademicYearRequired';
import type { AppRoute } from './types';
import { RedirectKeepingQuery } from './RedirectKeepingQuery';

function elementFor(route: AppRoute) {
  if (route.component) {
    const Component = route.component;
    // A year-scoped page waits for the working year (see AppRoute.yearScoped).
    return route.yearScoped ? (
      <AcademicYearRequired>
        <Component />
      </AcademicYearRequired>
    ) : (
      <Component />
    );
  }
  if (route.redirectTo) return <RedirectKeepingQuery to={route.redirectTo} />;
  return undefined;
}

function renderRoute(route: AppRoute, key: string) {
  if (route.children?.length) {
    return (
      <Route key={key} path={route.path} element={elementFor(route)}>
        {route.children.map((child, i) => renderRoute(child, `${key}-${i}`))}
      </Route>
    );
  }
  if (route.path === '') {
    return <Route key={key} index element={elementFor(route)} />;
  }
  return <Route key={key} path={route.path} element={elementFor(route)} />;
}

/** Converts declarative {@link AppRoute} definitions into `<Route>` elements. */
export function renderRoutes(routes: AppRoute[]) {
  return routes.map((route, i) => renderRoute(route, `${route.path || 'index'}-${i}`));
}
